function addActiveBundleToCard(selector, bundle, installed, esim, products) {
  let bundleUsage = bundle.assignment;
  let initialQuantity = bundleUsage.initialQuantity / 1000000000;
  let remainingQuantity = bundleUsage.remainingQuantity / 1000000000;
  let usedData = initialQuantity - remainingQuantity;

  //Add Plan Name and Map to Card
  if (products && products[bundle.name]) {
    if (products[bundle.name].product_map != undefined &&  products[bundle.name].product_map != '') {
      selector.querySelector('.bundle_details_map').setAttribute('src', products[bundle.name].product_map);
    }    
    selector.querySelector('.bundle_details_plan_name').innerText = products[bundle.name].product_title;
  }
  else{
    selector.querySelector('.bundle_details_plan_name').innerText = esim.productName;
  }

  if (installed) {
    // Set Usage Progress Bar Percentage
    selector.querySelector('.usage_data_progress_progress').setAttribute('value', (usedData / initialQuantity) * 100);

    let usageProgressSuffix = esimCardTranslations.gb_used;

    if (bundle.assignment.unlimited){
      usageProgressSuffix += " " + esimCardTranslations.unlimited_used; 
    }
    
    // Set Usage Heading Text
    if (usedData.toFixed(2) > 999) {
      usedData = usedData / 1000;
      selector.querySelector('.usage_data_progress_heading').innerText = usedData.toFixed(2) + esimCardTranslations.gb_of + " " + initialQuantity + usageProgressSuffix;
    } else {
      usedData = usedData * 1000;
      selector.querySelector('.usage_data_progress_heading').innerText = Math.round(usedData) + esimCardTranslations.mb_of + " " + initialQuantity + usageProgressSuffix;
    }

    //Set Usage Subtitle
    if (bundleUsage.remainingQuantity < 1.0) {
      selector.querySelector('.usage_data_progress_subheading').innerText = Math.round((remainingQuantity*1000)) + esimCardTranslations.mb_remaining;
    } else {
      selector.querySelector('.usage_data_progress_subheading').innerText = remainingQuantity.toFixed(1) + esimCardTranslations.gb_remaining;
    }
    
    let startTime = new Date(bundleUsage.startTime);
    let endTime = new Date(bundleUsage.endTime);
    let bundleLength = parseInt((endTime - startTime) / (1000 * 60 * 60 * 24), 10);
    let timeLeft = Math.floor((endTime - Date.now()) / (1000 * 3600 * 24));

    // Set Time Heading Text
    selector.querySelector('.remaining_days_progress_heading').innerText = bundleLength + esimCardTranslations.day_bundle_expires_prefix + timeLeft + esimCardTranslations.day_bundle_expires_suffix;

    // Set Time Progress Bar Percentage
    let exipiryBarData = Math.round(((Date.now() - startTime) / (endTime - startTime)) * 100);
    selector.querySelector('.remaining_days_progress_progress').setAttribute('value', exipiryBarData);

    //Set Time Subtitle
    let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let convertedTz = endTime.toLocaleString(undefined, {timeZone: tz, timeZoneName:'short'});
    selector.querySelector('.remaining_days_progress_subheading').innerText = esimCardTranslations.expires_on + convertedTz;
  }
}

/*
 * Checks whether this eSIM's ICCID is expired (deactivated after 6 months
 * of no usage) and, if so, marks the status text as "Expired" and reveals
 * the expired-message box. The top-up/install button is disabled by default
 * in the card's Liquid markup, since this check is async — this keeps it
 * non-clickable for the brief window before we know the eSIM's status,
 * rather than only disabling it after the fact. If the eSIM turns out not
 * to be expired, we re-enable it here.
 *
 * `expiryState` is also written here so the click handler can check the
 * real fetched result directly, rather than trusting the button's
 * `disabled` attribute — which can be cleared from devtools.
 *
 * @param {HTMLElement} cardEl - The eSIM card container element
 * @param {string} iccid - The ICCID to check
 * @param {{expired: boolean|null}} expiryState - shared with the click handlers
 */
async function applyEsimExpiredState(cardEl, iccid, expiryState) {
  const expired = await isEsimExpired(iccid);
  expiryState.expired = expired;

  const actionButton = cardEl.querySelector('.top_up_esim_button') || cardEl.querySelector('.install_esim_button');

  if (!expired) {
    if (actionButton) actionButton.disabled = false;
    return;
  }

  const statusText = cardEl.querySelector('.esim_card_status_text');
  if (statusText) {
    statusText.textContent = window.esimCardStrings.expired;
    statusText.classList.add('expired');
  }

  const expiredMessage = cardEl.querySelector('.esim_expired_message');
  if (expiredMessage) expiredMessage.style.display = 'flex';
}

function viewEsimDetails(iccid) {
  location.href= Shopify.routes.root + 'pages/esim-details/?iccid=' + iccid;
}

function findProductByTitle(title, products){
  return Object.entries(products).find(
    ([key, value]) => value.product_title === title
  )?.[0] || null;
}

function topUpEsim(iccid, currentBundle, products) {
    currentBundle = currentBundle.replace(" - ", " ");
  
    const bundleSku = findProductByTitle(currentBundle, products);
   
    sessionStorage.setItem("topUpIccid", iccid);

    if (products && products[bundleSku]) {
      sessionStorage.setItem("topUpCurrentBundle", products[bundleSku].parent_product);
      location.href= Shopify.routes.root + 'products/' + products[bundleSku].parent_product;
    }
    else {
      location.href= Shopify.routes.root + 'products';
    }
}